<template>
  <el-table-column :label="label" :prop="prop" class-name="remote-island-type-name" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '離島区分'
    },
    prop: {
      type: String,
      default: 'remote_island_type_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.remote-island-type-name {
      width: 8em;
    }
  }
}
</style>
